import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{!-- One NvTabs tab (page variant): a route link. Same inner parts as nv-tabs/tab (label width reserved by the strip modifier). --}}\n<LinkTo\n  @route={{@route}}\n  @models={{this.models}}\n  @query={{this.query}}\n  class=\'nv-tablist-tab {{if @current \"is-selected\"}}\'\n  aria-current={{if @current \'page\'}}\n  data-ui-part=\'tab\'\n  ...attributes\n>\n  {{#if @icon}}\n    <FaIcon @icon={{@icon}} class=\'nv-tablist-icon\' aria-hidden=\'true\' />\n  {{/if}}\n  <span class=\'nv-tablist-label\'><span class=\'nv-tablist-text\'>{{yield}}</span></span>\n  {{#if this.hasCount}}\n    <span class=\'nv-tablist-count\' aria-hidden={{if @countLabel \'true\'}} {{nv-flash-on-change @count}}>{{@count}}</span>\n    {{#if @countLabel}}\n      <span class=\'nv-sr-only\'>{{@countLabel}}</span>\n    {{/if}}\n  {{/if}}\n</LinkTo>\n");

/**
 * MAP (in-file navigation graph — keep in sync with the code):
 *   role:      component — one tab of NvTabs, page variant (a route link). Yielded by nv-tabs
 *              as `tabs.Link`; not meant to be used on its own.
 *   extends:   Component (@glimmer/component)
 *   template:  link.hbs
 *   args:      @route, @model | @models, @query   as LinkTo
 *              @current    boolean, marks the tab current (aria-current=page). Required when
 *                          the current route is not what LinkTo's own `active` matches (one
 *                          route serving several tabs through a query param)
 *              @icon, @count, @countLabel   as nv-tabs/tab
 *              ...attributes on the link (data-test hooks)
 *   uses:      LinkTo, FaIcon
 *   gotchas:   LinkTo also adds the class `active` on a route match; the stylesheet treats
 *              `.active` and `[aria-current=page]` alike, so a link without @current still
 *              looks current, but only @current gives screen readers aria-current.
 */
class NvTabsLink extends Component {
  get models() {
    if (this.args.models) return this.args.models;
    return this.args.model !== undefined ? [this.args.model] : [];
  }
  get query() {
    return this.args.query ?? {};
  }
  get hasCount() {
    return this.args.count !== null && this.args.count !== undefined && this.args.count !== '';
  }
}
setComponentTemplate(TEMPLATE, NvTabsLink);

export { NvTabsLink as default };
//# sourceMappingURL=link.js.map
